import { Component, OnInit } from "@angular/core";
import { CreateEventPopupComponent } from 'src/app/core/check/create-event-popup/create-event-popup.component';
import { SafetyDashboardService } from "src/app/services/safety-dashboard.service";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from 'moment';
import { Subscription } from "rxjs";
import { validateVerticalPosition } from "@angular/cdk/overlay";
import { CustomValidator } from "src/app/core/Validators/custom-validator";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { DatePipe } from '@angular/common';
import { Constants } from "src/app/constants";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'create-event',
  templateUrl: './create-event.component.html',
  styleUrls: ['./create-event.component.scss'],
  standalone: false // NOSONAR
})

export class CreateEventComponent implements OnInit {
  code: any;
  foreCastDate: any;
  list: any;
  list1: any;
  toyotaGUID: string;
  safetyRouteEventForm: FormGroup;
  subMenuDetailsForm: FormGroup;
  successMessage: any;
  errorMessage: any;
  severityList: any[] = [];
  regionList: any[] = [];
  lpList: any[] = [];
  tmTitleList: any[] = [];
  processList: any[] = [];
  losList: any[] = [];
  subscription: Subscription;
  burnDetail: boolean;
  otherDetail: boolean;
  subscription1: Subscription;
  submittedValue: any;
  showSubMenuForm: boolean = false;
  submitted: boolean;
  submitted1: boolean;
  checkpoints: any[];
  incidentTypes: any[];
  selectedIncidents: any[];
  num_car_left_comment: number = 1000;
  num_car_left_desc: number = 1000;
  num_car_left_incident: number = 1000;
  num_car_left_counter: number = 1000;
  num_car_left_prob: number = 1000;
  incident_details_limit: number = 2000;


  constructor(
    private readonly dialog: MatDialog,
    private readonly safetyDashboardService: SafetyDashboardService,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly DatePipe: DatePipe,
    public constants: Constants,) { }

  ngOnInit() {
    this.submitted = false;
    this.submitted1 = false;
    // ["FATALITY","AMPUTATION","LOSS OF HEARING", "FRACTURE", "INJURY","ILLNESS","LOSS OF SIGHT","HEAD INJURY","HOSPITALIZATION","NEAR MISS HIT","BURN","STOP","PROPERTY DAMAGE","OTHER" ]
    this.incidentTypes = [
      {

        name: 'Fatality',
        value: 'FATALITY',
      },
      {

        name: 'Amputation',
        value: 'AMPUTATION',
      },
      {

        name: 'Loss of hearing',
        value: 'LOSS OF HEARING',
      },
      {
        name: 'Fracture',
        value: 'FRACTURE',
      },
      {
        name: 'Injury',
        value: 'INJURY',
      },
      {

        name: 'Illness',
        value: 'ILLNESS',
      },
      {

        name: 'Loss of sight',
        value: 'LOSS OF SIGHT',
      },
      {

        name: 'Head Injury',
        value: 'HEAD INJURY',
      },
      {

        name: 'Hospitalization',
        value: 'HOSPITALIZATION',
      },
      {

        name: 'Near miss/hit',
        value: 'NEAR MISS HIT',
      },
      {

        name: 'Burn',
        value: 'BURN',
      },
      {

        name: 'Stop 6',
        value: 'STOP',
      },
      {

        name: 'Property Damage',
        value: 'PROPERTY DAMAGE',
      },
      {

        name: 'Other',
        value: 'OTHER',
      },
    ];
    this.checkpoints = [
      {
        name: 'Standardized Work Followed',
        value: '1',
      },
      {
        name: 'TM Trained On Process',
        value: '2',
      },
      {
        name: 'Safety Point Included In SOP',
        value: '3',
      },
      {
        name: 'Layout/Space Adequate For Process',
        value: '4',
      },
      {
        name: 'Equipment In Good Condition',
        value: '5',
      }];
    this.toyotaGUID = '';
    this.code = '';
    this.foreCastDate = '';
    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    this.creareSafetyRouteForm();
    this.dropDownList();
  }

  get form() {
    return this.safetyRouteEventForm.controls;
  }
  get f() {
    return this.subMenuDetailsForm.controls;
  }

  createSubMenuDetailsForm() {
    this.subMenuDetailsForm = this.formBuilder.group({
      commentsInput: ['', [Validators.required]],
      incidentDateTime: ['', [Validators.required]],
      incidentTime: ['00:00', [Validators.required]],
      severity: ['', [Validators.required]],
      trailer: ['', [Validators.required]],
      region: ['', [Validators.required]],
      lp: ['', [Validators.required]],
      tmTitle: [''],
      process: [''],
      los: [''],
      productionImpact: [''],
      productionImpackDesc: [''],
      incidentTypes: this.formBuilder.array(this.incidentTypes.map(_x => false)),
      burnTypeValue: [''],
      burnTextValue: [''],
      incidentTypeText: [''],
      productionImpack: '',
      details: ['', Validators.required],
      description: '',
      lpInitiated: '',
      causeOfIncident: '',
      checkpoints: this.formBuilder.array(this.checkpoints.map(_x => false)),
    })
    this.addCheckbox();
  }

  addCheckbox() {
    const checkboxControl = (this.subMenuDetailsForm.controls['checkpoints'] as FormArray);
    this.subscription = checkboxControl.valueChanges.subscribe(_checkbox => {
      checkboxControl.setValue(
        checkboxControl.value.map((value, i) => value ? this.checkpoints[i].value : false),
        { emitEvent: false }
      );
    });

    const checkboxControl1 = (this.subMenuDetailsForm.controls['incidentTypes'] as FormArray);
    checkboxControl1.setValidators(CustomValidator.anyIncident);
    this.subscription1 = checkboxControl1.valueChanges.subscribe(_incident => {
      checkboxControl1.setValue(
        checkboxControl1.value.map((value, i) => value ? this.incidentTypes[i].value : false),
        { emitEvent: false }
      );
    });
  }

  dropDownList() {
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.safetyDashboardService.getDropdownData()?.subscribe((res) => {
      this.ngxUiLoaderService?.stop(CommonConstant.loader);
      if (Array.isArray(res)) {
        const mappedResponse = this.mapCriteriaFiltersResponse(res);
        this.severityList = mappedResponse.severityList;
        this.regionList = mappedResponse.regionList;
        this.lpList = mappedResponse.lpList;
        this.tmTitleList = mappedResponse.tmTitleList;
        this.processList = mappedResponse.processList;
        this.losList = mappedResponse.losList;
      } else {
        this.severityList = this.normalizeItemList(res?.severity);
        this.regionList = this.normalizeItemList(res?.regionList);
        this.lpList = this.normalizeVendorList(res?.vendorList);
        this.tmTitleList = this.normalizeItemList(res?.tmTitle);
        this.processList = this.normalizeItemList(res?.process);
        this.losList = this.normalizeItemList(res?.lengthOfService);
      }
      this.sortDropdownListsAlphabetically();
      this.createSubMenuDetailsForm();




    }, (error) => {
      this.ngxUiLoaderService?.stop(CommonConstant.loader);
      console.info(error);
    })



  }

  private normalizeItemList(list: any): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((item: any) => ({
      ...item,
      itemDesc:
        item?.itemDesc ??
        item?.itemDescription ??
        item?.description ??
        item?.name ??
        item?.label ??
        item?.regionDesc ??
        item?.safetyServCode ??
        item?.safetyTitleDesc ??
        item?.safetyProcessDesc ??
        item?.sftyLenDesc ??
        '',
      itemCode:
        item?.itemCode ??
        item?.code ??
        item?.itemCd ??
        item?.id ??
        item?.regionCode ??
        item?.safetyProcessCode ??
        '',
    }));
  }

  private normalizeVendorList(list: any): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((vendor: any) => ({
      ...vendor,
      vendorCode:
        vendor?.vendorCode ??
        vendor?.vendorCd ??
        vendor?.code ??
        vendor?.itemCode ??
        vendor?.name ??
        vendor?.shortName ??
        '',
      vendorId: vendor?.vendorId ?? vendor?.vendorID ?? vendor?.id ?? '',
    }));
  }

  private mapCriteriaFiltersResponse(filters: any[]): {
    regionList: any[];
    severityList: any[];
    lpList: any[];
    tmTitleList: any[];
    processList: any[];
    losList: any[];
  } {
    const findFilter = (keywords: string[]): any =>
      filters.find((filter: any) => {
        const label = (filter?.label ?? '').toString().toLowerCase();
        return keywords.some((keyword) => label.includes(keyword));
      });

    const toItemList = (filter: any): any[] => {
      const values = filter?.values ?? {};
      return Object.entries(values).map(([key, value]) => ({
        itemCode: key,
        itemDesc: (value ?? key)?.toString(),
      }));
    };

    const toVendorList = (filter: any): any[] => {
      const values = filter?.values ?? {};
      return Object.entries(values).map(([key, value]) => ({
        vendorId: key,
        vendorCode: (value ?? key)?.toString(),
      }));
    };

    const regionFilter = findFilter(['region']);
    const severityFilter = findFilter(['severity']);
    const lpFilter = findFilter(['logistic', 'lp', 'partner']);
    const tmTitleFilter = findFilter(['t/m', 'tm title', 'title', 'team member']);
    const processFilter = findFilter(['process']);
    const losFilter = findFilter(['length of service', 'length', 'service']);

    return {
      regionList: toItemList(regionFilter),
      severityList: toItemList(severityFilter),
      lpList: toVendorList(lpFilter),
      tmTitleList: toItemList(tmTitleFilter),
      processList: toItemList(processFilter),
      losList: toItemList(losFilter),
    };
  }

  private sortDropdownListsAlphabetically(): void {
    this.regionList = this.sortByDisplayValue(this.regionList);
    this.severityList = this.sortByDisplayValue(this.severityList);
    this.lpList = this.sortByDisplayValue(this.lpList);
    this.tmTitleList = this.sortByDisplayValue(this.tmTitleList);
    this.processList = this.sortByDisplayValue(this.processList);
    this.losList = this.sortByDisplayValue(this.losList);
  }

  private sortByDisplayValue<T>(list: T[]): T[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return [...list].sort((a: any, b: any) =>
      this.getDisplayValue(a).localeCompare(this.getDisplayValue(b), undefined, { sensitivity: 'base' })
    );
  }

  private getDisplayValue(item: any): string {
    return (
      item?.itemDesc ??
      item?.vendorCode ??
      item?.label ??
      item?.value ??
      ''
    ).toString().trim();
  }

  creareSafetyRouteForm() {
    this.safetyRouteEventForm = this.formBuilder.group({
      routeName: ['', [Validators.required]],
      plannedUnload: ['', [Validators.required]],
    });
  }

  verifyRouteFormat(value) {
    let s2 = [];
    let s3 = [];
    const routeName = value.trim();
    const s = routeName.split("-");
    if (s.length != 2) {        // NOSONAR
      return false;
    }
    s2 = s.length > 0 ? s[0] : []
    if (s2.length > 7) {
      return false;
    }
    s3 = s.length > 1 ? s[1] : [];
    if (s3.length > 2) {
      return false;
    }
    return true;
  }

  createValidations() {
    this.successMessage = null;
    this.errorMessage = null;
    let returnVal = true;
    if (this.safetyRouteEventForm.invalid) {
      returnVal = false;
    }
    return returnVal
  }

  onCreate() {
    this.submitted = true;
    this.showSubMenuForm = false;
    if (!this.createValidations()) {
      return;
    }
    this.formatValidation();
  }
  formatValidation() {
    const routeNameId = this.safetyRouteEventForm.controls['routeName'].value;
    const unload = this.safetyRouteEventForm.controls['plannedUnload'].value;
    const todayStore = new Date()
    const todayString = this.DatePipe.transform(todayStore, 'yyyy-MM-dd');
    const today = new Date(todayString).getTime();
    const unloadTime = unload ? new Date(unload).getTime() : null;
    if (routeNameId && routeNameId.toUpperCase() != 'XXX-01') {          // NOSONAR
      if (!this.verifyRouteFormat(routeNameId)) {
        this.errorMessage = "Please Enter a valid route (XXX-YY)";
        return;
      }
      if (unload && unloadTime < today) {
        this.popup();
      } else {

        this.onCreateAPI();
      }

    } else if (unload && unloadTime < today) {
      this.popup();
    } else {
      this.showSubMenuForm = true;
    }

  }

  onCreateAPI() {
    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    const routeName = this.safetyRouteEventForm.controls['routeName'].value;
    const plannedUnload = this.safetyRouteEventForm.controls['plannedUnload'].value;
    let arrivalValue = plannedUnload;

    if (plannedUnload) {
      arrivalValue = this.DatePipe.transform(
        plannedUnload.substring(0, 10),
        'MM/dd/yyyy'
      );
    }


    const data = {
      puRoute: routeName.toUpperCase(),
      //arrival: plannedUnload ? plannedUnload = moment(plannedUnload).format('MM/DD/YYYY') : plannedUnload
      arrival: arrivalValue,

    }
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.safetyDashboardService.validateSafetyEventRoute(data)?.subscribe((res) => {
      this.ngxUiLoaderService?.stop(CommonConstant.loader);
      if (res.validRoute > 0) {
        if (res.eventId != -1) {     // NOSONAR
          this.showSubMenuForm = false;
          if (res.status != "CLOSED") {          // NOSONAR
            this.errorMessage = ' Event already exists.';
            return;
          } else {
            this.errorMessage = 'Event exists, but is currently closed.';
            return;
          }

        } else {
          this.showSubMenuForm = true;
        }
      } else {
        this.showSubMenuForm = false;
        this.errorMessage = ' Route does not exist in OWK on the Planned Unload date. ';
      }

    }, (error) => {
      this.ngxUiLoaderService?.stop(CommonConstant.loader);
      console.info(error);
      this.errorMessage = this.constants.APIErrorMessage;
      this.showSubMenuForm = false;
    });
  }

  getCharactersLeft(value, type) {
    if (type == 'event') {  // NOSONAR
      this.num_car_left_comment = 1000 - value.target.value.length;
    } else if (type == 'desc') {  // NOSONAR
      this.num_car_left_desc = 1000 - value.target.value.length;
    } else if (type == 'incident') {  // NOSONAR
      this.num_car_left_incident = 1000 - value.target.value.length;
    } else if (type == 'counter') {  // NOSONAR
      this.num_car_left_counter = 1000 - value.target.value.length;
    } else if (type == 'prob') {  // NOSONAR
      this.num_car_left_prob = 1000 - value.target.value.length;
    }
    else if (type == 'details') {  // NOSONAR
      this.incident_details_limit = 2000 - value.target.value.length;
    }
  }

  submitValidations() {
    let returnVal = true;
    if (this.subMenuDetailsForm.invalid) {
      returnVal = false;
    }
    return returnVal;
  }


  /* convertFrom24To12Format(incidentTime) {
    let hour = (incidentTime.split(':'))[0];
    let min = (incidentTime.split(':'))[1];
    const sec = '00';
    //let part = hour > 12 ? 'pm' : 'am';
    if(parseInt(hour) == 0)
    hour = 12;
    min = (min+'').length == 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour+'').length == 1 ? `0${hour}` : hour;
    return `${hour}:${min}:${sec}`
  } */
  onSubmit() {

    this.submitted1 = true;
    if (!this.submitValidations()) {
      return;
    }
    const incidentTypeControl = (this.subMenuDetailsForm.controls['incidentTypes'] as FormArray);
    const probInvestCheckPoint = (this.subMenuDetailsForm.controls['checkpoints'] as FormArray);
    const formValue = {
      ...this.subMenuDetailsForm.value,
      incidentTypes: incidentTypeControl.value.filter(value => !!value)
    }

    const formValue1 = {
      ...this.subMenuDetailsForm.value,
      checkpoints: probInvestCheckPoint.value.filter(value => !!value)
    }

    this.toyotaGUID = localStorage.getItem('toyotaGUID');
    const routeName = this.safetyRouteEventForm.controls['routeName'].value;
    let plannedUnload = this.safetyRouteEventForm.controls['plannedUnload'].value;
    let formattedRouteDate = this.dateFormatter(plannedUnload);

    if (!formattedRouteDate) {
      plannedUnload = '';
      formattedRouteDate = '';
    }

    console.info(plannedUnload)
    const data = {
      oper: "getSubmitted",
      routeDate: formattedRouteDate,
      puRoute: routeName ? routeName.toUpperCase() : '',
      reportTypeValue: "INITIAL REPORT",
      incidentSummaryValue: this.f['commentsInput'].value,
      incidentDateTimeValue: this.dayFormatter(this.f['incidentDateTime'].value) ? `${this.dayFormatter(this.f['incidentDateTime'].value)}${' '}${this.f['incidentTime'].value}${':00'}` : '',
      severityValue: this.f['severity'].value ? this.f['severity'].value.itemCode : '',
      logisticPointValue: this.f['lp'].value ? this.f['lp'].value.vendorCode : '',
      logisticPointId: this.f['lp'].value ? this.f['lp'].value.vendorId : '',
      tmTitle: this.f['tmTitle'].value ? this.f['tmTitle'].value.itemCode : '',
      processValue: this.f['process'].value ? this.f['process'].value.itemCode : '',
      lengthOfService: this.f['los'].value ? this.f['los'].value.itemCode : '',
      description: this.f['description'].value,
      causeOfIncident: this.f['causeOfIncident'].value,
      lpInitiatedCountMes: this.f['lpInitiated'].value,
      productionImpact: this.f['productionImpact'].value,
      burningValue: this.f['burnTypeValue'].value,
      burningTextValue: this.f['burnTypeValue'].value ? this.f['burnTextValue'].value : '',
      stopValue: this.f['incidentTypeText'].value,
      regionCode: this.f['region'].value ? this.f['region'].value.itemCode : '',
      trailerNumber: this.f['trailer'].value ? this.f['trailer'].value.toUpperCase() : '',
      probInvestCheckPointDesc: this.f['productionImpact'].value ? this.f['productionImpackDesc'].value : '',
      incidentDetails: this.f['details'].value,
      incidentType: formValue.incidentTypes,
      probInvestCheckPoint: formValue1.checkpoints
    }


    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.safetyDashboardService.submitCreateEvent(this.toyotaGUID, data)?.subscribe((_res) => {

      this.ngxUiLoaderService.stop(CommonConstant.loader);
      // this.successMessage =
      this.router.navigateByUrl('/safety-dashboard');
    }, (error) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.errorMessage = this.constants.APIErrorMessage;
      console.info(error);
    });
  }

  onCancel() {
    this.router.navigateByUrl('/safety-dashboard');
  }

  resetSubMenuDetailsForm() {
    this.subMenuDetailsForm.patchValue({
      commentsInput: '',
      details: '',
      productionImpackDesc: '',
      description: '',
      lpInitiated: '',
      causeOfIncident: '',
    })
    this.num_car_left_comment = 1000;
    this.num_car_left_desc = 1000;
    this.num_car_left_incident = 1000;
    this.num_car_left_counter = 1000;
    this.num_car_left_prob = 1000;
    this.incident_details_limit = 2000;
  }

  popup() {
    const dialogRef = this.dialog?.open(CreateEventPopupComponent, {
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'proceed') {  // NOSONAR
          const routeNameId = this.safetyRouteEventForm.controls['routeName'].value;
          if (routeNameId && routeNameId.toUpperCase() != 'XXX-01') {          // NOSONAR
            this.onCreateAPI();
          }
          else {
            this.showSubMenuForm = true;
          }

        }
      }
    );
  }



  onRegionChange(_e: any) {
    // do nothing
  }

  onSeverityChange(_event: any) {
    // do nothing
  }

  onIncidentDateChange(_event: any) {
    // do nothing
  }

  onLPChange(_event: any) {
    // do nothing
  }

  onTrailerChange(_event: any) {
    // do nothing
  }

  checkedHandler(event: any) {
    console.info(event)
  }
  onIncidentTypesChange() {
    const incident = this.f['incidentTypes'].value;
    const otherFound = incident.find(element => element == 'OTHER');  // NOSONAR
    if (otherFound) {
      this.otherDetail = true;
      this.f['incidentTypeText'].setValidators(Validators.required);
      this.f['incidentTypeText'].updateValueAndValidity();
    } else {
      this.otherDetail = false;
      this.f['incidentTypeText'].clearValidators();
      this.f['incidentTypeText'].updateValueAndValidity();
    }
    const burnFound = incident.find(element => element == 'BURN');  // NOSONAR
    if (burnFound) {
      this.burnDetail = true;
      this.f['burnTypeValue'].setValidators(Validators.required);
      this.f['burnTypeValue'].updateValueAndValidity();

    } else {
      this.burnDetail = false;
      this.f['burnTypeValue'].clearValidators();
      this.f['burnTypeValue'].updateValueAndValidity();

    }
  }

  onProductionImpack() {
    if (this.f['productionImpact'].value == 'YES') {  // NOSONAR
      this.f['productionImpackDesc'].setValidators([Validators.required]);
      this.f['productionImpackDesc'].updateValueAndValidity();
    } else {
      this.f['productionImpackDesc'].clearValidators();
      this.f['productionImpackDesc'].updateValueAndValidity();
    }
  }

  onBurnTypeChange() {


  }

  onBurnTextValue() {
    if (this.f['burnTextValue'].value) {
      this.f['burnTextValue'].setValidators([CustomValidator.numeric]);
      this.f['burnTextValue'].updateValueAndValidity();
    } else {
      this.f['burnTextValue'].clearValidators();
      this.f['burnTextValue'].updateValueAndValidity();
    }
  }
  dayFormatter(val) {
    if (val == null) { return ''; }  // NOSONAR
    else { return moment(val).format('MM-DD-YYYY'); }
  }
  dateFormatter(value) {
    if (value == null) { return ''; }  // NOSONAR
    else { return moment(value).format('MM-DD-YYYY HH:mm:ss'); }
  }
}
